import React, { memo } from 'react';

import OnCallBadgeIcon from '../../assets/images/on-call-badge-icon.svg';
import MarkedAsCallbackBadgeIcon from '../../assets/images/marked-as-callback-badge-icon.svg';
import CallbackShiftBadgeIcon from '../../assets/images/callback-shift-badge-icon.svg';

import './OnCallBadge.scss';

const OnCallSlotBadge = ({ slot, isPastShiftBadge = false }) => {
	if (!slot) {
		return null;
	}

	// if on-call slot is not marked as called back, we show the on-call badge
	const isOnCall = slot.is_on_call && (isPastShiftBadge || !slot.marked_as_callback);
	// if on-call slot is marked as called back, we show the marked as called back badge
	const isMarkedAsCalledBack = slot.is_on_call && slot.marked_as_callback && !isPastShiftBadge;
	// if slot is callback, we show the callback badge
	const isCallback = !!slot.on_call_slot_id;

	return (
		<div className="on-call-badge">
			<span className="on-call-badge__icon">
				{isOnCall && <img src={OnCallBadgeIcon} alt="on-call-badge-icon" />}
				{isMarkedAsCalledBack && <img src={MarkedAsCallbackBadgeIcon} alt="marked-as-callback-badge-icon" />}
				{isCallback && <img src={CallbackShiftBadgeIcon} alt="callback-shift-badge-icon" />}
			</span>
			<span className="on-call-badge__label">
				{isOnCall && 'On Call shift'}
				{isMarkedAsCalledBack && 'Marked as Called Back'}
				{isCallback && 'Callback shift'}
			</span>
		</div>
	);
};

export default memo(OnCallSlotBadge);
